annualPeriod